<template>
  <div class="app-container">
    <div class="form-container">
      <div class="filter-view">
        <el-form ref="form" :inline="true">
          <div style="display: flex; flex-wrap: wrap">
            <el-form-item label="项目更新时间" class="page_filter_item">
              <el-date-picker
                v-model="queryParams.beginDateTime"
                placeholder="选择开始时间"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
              至
              <el-date-picker
                v-model="queryParams.endDateTime"
                :default-time="'23:59:59'"
                placeholder="选择结束时间"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item label="项目名称" class="page_filter_item">
              <el-input
                v-model="queryParams.name"
                placeholder="请输入项目名称"
                class="project_my_input_search"
                type="text"
              />
            </el-form-item>
            <el-form-item label="项目状态" class="page_filter_item">
              <el-select v-model="queryParams.status">
                <el-option
                  v-for="status in projectStatusList"
                  :label="status.name"
                  :value="status.code"
                  :key="'status' + status.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌" class="page_filter_item">
              <el-select v-model="queryParams.brandCodes" collapse-tags multiple clearable placeholder="全部">
                <el-option
                  v-for="brand in brandList"
                  :key="brand.code"
                  :label="brand.name"
                  :value="brand.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-button class="ml-20 page_filter_item" round icon="el-icon-search" type="primary" @click="filterProject"
              >查询</el-button
            >
            <el-button class="page_filter_item" round plain icon="el-icon-refresh" @click="resetSearForm"
              >重置</el-button
            >
          </div>
          <div class="flex-space-between" style="width: 88%">
            <el-button v-permission="['myProject_create']" icon="el-icon-plus" type="primary" @click="creatProject">
              创建表单
            </el-button>
            <el-form-item>
              <el-button-group>
                <el-button
                  :type="dataShowType == 'card' ? 'primary' : 'default'"
                  size="mini"
                  @click="dataShowType = 'card'"
                >
                  <font-icon class="fas fa-th-large" />
                </el-button>
                <el-button
                  :type="dataShowType == 'table' ? 'primary' : 'default'"
                  size="mini"
                  @click="dataShowType = 'table'"
                >
                  <font-icon class="fas fa-th-list" />
                </el-button>
              </el-button-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <form-card-list
        v-if="dataShowType == 'card'"
        v-loading="projectListLoading"
        :project-list.sync="projectList"
        @refresh="queryProjectPage"
        @copyProject="copyProject"
        @openPreviewHandle="openPreviewHandle"
        @editProject="editProject"
        @addProjectAssistant="addProjectAssistant"
      />
      <my-form-table
        v-if="dataShowType == 'table'"
        v-loading="projectListLoading"
        :project-list.sync="projectList"
        @refresh="queryProjectPage"
        @copyProject="copyProject"
        @openPreviewHandle="openPreviewHandle"
        @editProject="editProject"
        @addProjectAssistant="addProjectAssistant"
      />
      <div class="project-page-view">
        <el-pagination
          v-if="total > 10"
          :current-page.sync="queryParams.current"
          :page-size.sync="queryParams.size"
          :total="total"
          background
          layout="total, prev, pager, next"
          @current-change="queryProjectPage"
        />
      </div>
    </div>
    <el-dialog
      class="create-form-dialog"
      :visible.sync="projectFormVisible"
      :title="projectDialogTitle[titleCode]"
      @close="resetForm"
      width="560px"
    >
      <el-form ref="createForm" :model="formData" label-width="110px" class="create-project-form">
        <el-form-item prop="name" label="表单名称" :rules="{ required: true, message: '名称不能为空' }">
          <el-input v-model="formData.name" autocomplete="off" placeholder="请输入表单名称" />
        </el-form-item>
        <el-form-item label="描述信息" prop="description">
          <el-input v-model="formData.description" :rows="3" autocomplete="off" type="textarea" placeholder="请输入描述信息" />
        </el-form-item>
        <el-form-item class="section-title-item">
          <span slot="label" class="section-label">
            可见权限
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                1.如果同时选择了品牌和门店，则默认拥有该品牌和门店权限的用户及其他协作者可见该问卷<br />
                2.如果仅选择了品牌或均未选择，则仅创建人及其他协作者可见该问卷
              </div>
              <i class="el-icon-question section-help" />
            </el-tooltip>
          </span>
        </el-form-item>
        <el-form-item label="品牌" prop="brandCode">
            <el-select
              v-model="formData.brandCode"
              style="width: 100%"
              clearable
              placeholder="请选择"
              @change="handleSelectBrand"
            >
              <el-option v-for="brand in brandList" :key="brand.code" :label="brand.name" :value="brand.code" />
            </el-select>
            <div v-if="brandCodeIsNull" class="brand_code_error">请选择品牌</div>
          </el-form-item>
          <el-form-item label="门店" prop="shopCodes">
            <treeselect
              v-model="formData.shopCodes"
              :multiple="true"
              :limit="1"
              :options="shopOptions"
              :limitText="limitText"
              placeholder="请选择"
              noChildrenText="无数据"
              :normalizer="normalizer"
              @close="handleCloseTree"
              @open="focus"
            />
          </el-form-item>
        <permission-config-panel
          v-if="showPermissionConfigPanel"
          v-model="permissionFormData"
          :show-description="false"
          label-width="110px"
        />
      </el-form>
      <span slot="footer" class="create-form-dialog-footer">
        <el-button type="text" class="cancel-btn" @click="projectFormVisible = false">取 消</el-button>
        <el-button type="primary" :loading="requestLoading.pushFormData" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 预览问卷 -->
    <el-dialog :visible.sync="previewDialogVisible" destroy-on-close fullscreen>
      <pre-view ref="preViewRef" :key="previewKey" :preview-qrcode="true" :formPropKey="formKey" />
    </el-dialog>
    <!-- 提示 -->
    <el-dialog :visible.sync="infoDialogVisible" destroy-on-close title="确认" width="45%">
      <el-alert
        title="请注意，如果同时选择了品牌和门店，则默认拥有该品牌和门店权限的用户可见该问卷；如果仅选择了品牌或均未选择，则仅创建人可见该问卷，如需分享给其他用户，请添加协作者。"
        type="warning"
        :closable="false"
        show-icon
      >
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button @click="infoDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <assistant-dialog ref="assistantRef" @saved="queryProjectPage"></assistant-dialog>
  </div>
</template>
<script>
import {
  createFormRequest,
  getProjectDetailRequest,
  getFormPermission,
  pageFormRequest,
  updateProjectRequest,
  copyFormRequest,
  getUserBrandList,
  getShopByBrand
} from '@/api/project/form'
import FormCardList from './card'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import mixin from './mixin'
import ShopTreeSelectMinxin from '@/mixin/ShopTreeSelectMinxin'
import MyFormTable from './table'
import PreView from '@/views/form/preview'
import assistantDialog from './components/assistant-dialog.vue'
import PermissionConfigPanel from './components/permission-config-panel.vue'
import { removeHtmlTag } from '@/utils'
import { formConf } from '@/components/FormGen/GenerateForm/config'

let searchParams = null
export default {
  name: 'MyProject',
  components: {
    MyFormTable,
    FormCardList,
    PreView,
    Treeselect,
    assistantDialog,
    PermissionConfigPanel
  },
  mixins: [mixin, ShopTreeSelectMinxin],
  data() {
    return {
      projectFormVisible: null,
      dataShowType: 'card',
      total: 0,
      queryParams: {
        current: 1,
        size: 12,
        name: '',
        beginDateTime: null,
        endDateTime: null,
        status: '',
        folderId: 0,
        brandCodes: []
      },
      titleCode: 'create',
      formData: {},
      brandList: [], // 账号拥有的品牌权限集合
      // shopOptions: [],
      projectList: [],
      projectListLoading: true,
      pageCurrent: '',
      requestLoading: {
        // 请求加载中状态
        pushFormData: false,
        pushFolderData: false
      },
      previewKey: +new Date(),
      previewDialogVisible: false,
      formKey: '',
      infoDialogVisible: false,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      limitText(counnt) {
        return `+${counnt}`
      },
      brandCodeIsNull: false,
      permissionFormData: {
        editPermissionMode: 'VIEW_BASED',
        assistants: [],
        editors: []
      },
      canManageProjectPermission: true
    }
  },
  computed: {
    showPermissionConfigPanel() {
      return this.titleCode !== 'edit' || this.canManageProjectPermission
    }
  },
  beforeRouteEnter(to, from, next) {
    const reg = /\/form\/(editor|data|statistics)/i
    //  清空搜索项
    if (!reg.test(from.path)) {
      searchParams = null
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    searchParams = {
      queryParams: this.queryParams,
      dataShowType: this.dataShowType
    }
    next()
  },
  created() {
    this.resetForm()
    // 搜索缓存
    if (searchParams) {
      const { queryParams, dataShowType } = searchParams
      this.queryParams = queryParams
      this.dataShowType = dataShowType
    }
    this.queryProjectPage()
    this.getAllBrandData()
  },
  beforeDestroy() {},
  methods: {
    resetSearForm() {
      this.queryParams = {
        current: 1,
        size: 12,
        name: '',
        beginDateTime: null,
        endDateTime: null,
        status: '',
        folderId: 0,
        brandCodes: []
      }
      this.queryProjectPage()
    },
    resetForm() {
      this.formData = {
        description: '',
        name: '未命名问卷',
        type: 0,
        brandCode: '',
        shopCodes: []
      }
      this.permissionFormData = {
        editPermissionMode: 'VIEW_BASED',
        assistants: [],
        editors: []
      }
      this.canManageProjectPermission = true
      this.shopOptions = []
    },
    filterProject() {
      this.queryParams.current = 1
      this.queryProjectPage()
    },
    queryProjectPage() {
      this.projectListLoading = true
      pageFormRequest(this.queryParams)
        .then((res) => {
          let { records, total, size } = res.data
          this.projectList = records
          this.total = total
          this.queryParams.size = size
        })
        .finally(() => {
          this.projectListLoading = false
        })
    },
    getAllBrandData() {
      getUserBrandList().then((res) => {
        this.brandList = res.data
      })
    },
    async handleSelectBrand(val) {
      this.formData.shopCodes = []
      this.shopOptions = []
      if (val) {
        this.brandCodeIsNull = false
        const { data } = await getShopByBrand([val])
        this.formateShopList(data)
      }
    },
    handleCloseTree(item) {
      this.formData.shopCodes = item
    },
    focus() {
      this.brandCodeIsNull = this.formData.brandCode === ''
    },
    handleSubmit() {
      this.$refs['createForm'].validate((valid) => {
        const doSomething = () => {
          const { formData, infoDialogVisible, titleCode } = this
          if ((formData.brandCode === '' || formData.shopCodes?.length === 0) && !infoDialogVisible) {
            this.infoDialogVisible = true
            return
          }
          return this[`${titleCode}FormHandle`]()
        }
        valid && doSomething()
      })
    },
    createFormHandle() {
      // 默认创建到当前打开文件夹
      const { description, shopCodes } = this.formData
      let params = { ...this.formData }
      params.shopCodes = this.getSelectedShopId(shopCodes)
      params.description = description || formConf.description
      params.folderId = this.queryParams.folderId || 0
      params.name = `<h2 style="text-align: center;">${params.name}</h2>`
      params = { ...params, ...this.buildPermissionPayload(true) }
      this.requestLoading.pushFormData = true
      // 给默认输入的标题加粗
      createFormRequest({ ...params })
        .then((res) => {
          this.toProjectHandle(res.data, 'editor')
          this.clearCache()
          this.requestLoading.pushFormData = false
          this.resetForm()
        })
        .catch(() => {
          this.requestLoading.pushFormData = false
        })
    },
    // 编辑
    editFormHandle() {
      const { description, name, brandCode, shopCodes, formId, formKey } = this.formData
      const params = {
        newTitle: name,
        newDesc: description,
        newBrandCode: brandCode,
        newShopCodes: this.getSelectedShopId(shopCodes),
        formId,
        formKey
      }
      Object.assign(params, this.buildPermissionPayload(this.canManageProjectPermission))
      updateProjectRequest({ ...params }).then((res) => {
        if (res) {
          this.clearCache()
          this.success('编辑成功')
        }
      })
    },
    copyFormHandle() {
      this.requestLoading.pushFormData = true
      const { description, name, originFormKey, brandCode, shopCodes } = this.formData
      const params = {
        formName: name,
        desc: description || formConf.description,
        originFormKey,
        brandCode,
        shopCodes: this.getSelectedShopId(shopCodes)
      }
      Object.assign(params, this.buildPermissionPayload(true))
      copyFormRequest({ ...params })
        .then((res) => {
          if (res) {
            this.clearCache()
            this.success('复制成功')
          }
        })
        .finally(() => {
          this.requestLoading.pushFormData = false
        })
    },
    success(text) {
      this.$message.success(text)
      this.projectFormVisible = false
      this.infoDialogVisible = false
      this.queryProjectPage()
      this.requestLoading.pushFormData = false
    },
    creatProject() {
      this.projectFormVisible = true
      this.titleCode = 'create'
      this.resetForm()
    },
    async editProject(formKey) {
      const [{ data }, permissionRes] = await Promise.all([getProjectDetailRequest(formKey), getFormPermission(formKey)])
      const { brand, desc, formTitle, shopList } = data
      const permissionData = permissionRes?.data || {}
      const noHtmlTagName = removeHtmlTag(formTitle)
      this.formData = { ...this.formData, ...data, name: noHtmlTagName, description: desc }
      this.permissionFormData = {
        editPermissionMode: permissionData.editPermissionMode || 'VIEW_BASED',
        assistants: permissionData.assistants || [],
        editors: permissionData.editors || []
      }
      this.canManageProjectPermission = !!permissionData.isOwner || this.checkButtonPermission('project_collaboration')
      this.titleCode = 'edit'
      if (brand) {
        this.formData.brandCode = brand.code
        this.handleSelectBrand(brand.code)
      }
      if (shopList?.length > 0) {
        const codeArr = shopList.map((item) => item.id)
        this.formData.shopCodes = codeArr
      }
      this.projectFormVisible = true
    },
    async copyProject(formKey) {
      const { data } = await getProjectDetailRequest(formKey)
      const { formTitle, desc: description, brand, shopList } = data
      brand && (await this.handleSelectBrand(brand.code))
      const noHtmlTagName = removeHtmlTag(formTitle)
      this.titleCode = 'copy'
      this.projectFormVisible = true
      this.canManageProjectPermission = true
      this.permissionFormData = {
        editPermissionMode: 'VIEW_BASED',
        assistants: [],
        editors: []
      }
      this.formData = {
        ...this.formData,
        description,
        name: noHtmlTagName + ' -副本',
        originFormKey: formKey,
        brandCode: brand?.code || ''
      }
      if (shopList?.length > 0) {
        const codeArr = shopList.map((item) => item.id)
        this.formData.shopCodes = codeArr
      }
    },
    addProjectAssistant(formKey) {
      this.$refs.assistantRef.open(formKey)
    },
    openPreviewHandle(key) {
      this.formKey = key
      this.previewKey = +new Date()
      localStorage.setItem('formKey', key)
      this.previewDialogVisible = true
    },
    buildPermissionPayload(includePermission) {
      if (!includePermission) {
        return {}
      }
      return {
        assistantUserIds: this.permissionFormData.assistants.map((item) => item.userId),
        editPermissionMode: this.permissionFormData.editPermissionMode,
        editorUserIds: this.permissionFormData.editors.map((item) => item.userId)
      }
    },
    checkButtonPermission(code) {
      const permission = JSON.parse(this.$store.state.user.buttonRoles || '[]')
      return permission.includes(code)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  width: 100%;
  height: 100%;
  padding-top: 50px;
  padding-left: 90px;
}

.form-container {
  margin: 0 auto;
}

.project-page-view {
  margin-top: 30px;
  text-align: center;
}

.form-breadcrumb {
  margin: 10px 50px 10px 0px;
}

::v-deep .el-breadcrumb__inner {
  cursor: pointer !important;
}

.brand_code_error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 2px;
  position: absolute;
  top: 100%;
  left: 0;
}

.filter-view .el-form-item {
  margin-bottom: 0px !important;
}

.create-project-form {
  ::v-deep .section-title-item {
    margin-bottom: 4px;

    .el-form-item__content {
      display: none;
    }

    .el-form-item__label {
      font-weight: 600;
      line-height: 32px;
    }
  }

  .section-label {
    display: inline-flex;
    align-items: center;
  }

  .section-help {
    margin-left: 4px;
    color: #c0c4cc;
    font-size: 14px;
    cursor: pointer;
    font-weight: normal;
  }

  ::v-deep .el-form-item__label {
    text-align: right;
    color: #303133;
  }

  ::v-deep .el-input__inner,
  ::v-deep .el-textarea__inner {
    border-radius: 4px;
    border-color: #dcdfe6;
  }
}
</style>

<style lang="scss">
.create-form-dialog {
  border-radius: 10px !important;

  .el-dialog__body {
    padding: 20px 24px 10px;
  }

  .el-dialog__title {
    font-weight: 600;
    color: #303133;
  }

  .create-form-dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    padding-bottom: 8px;

    .cancel-btn {
      color: #00a3ff;
      padding: 0;

      &:hover,
      &:focus {
        color: #33b5ff;
      }
    }

    .el-button--primary {
      background-color: #00a3ff;
      border-color: #00a3ff;
      border-radius: 4px;
      min-width: 88px;

      &:hover,
      &:focus {
        background-color: #33b5ff;
        border-color: #33b5ff;
      }
    }
  }

  .vue-treeselect__control {
    border-radius: 4px;
    border-color: #dcdfe6;
    min-height: 32px;
  }
}
</style>

<style lang="scss">
.project_my_input_search {
  width: auto;
  .el-input__inner {
    border-bottom-right-radius: 0px !important;
    border-top-right-radius: 0px !important;
  }
}
</style>
